import * as React from "react";
import "./index.css";
import { Link, NavLink } from "react-router-dom";
import Observer from '@researchgate/react-intersection-observer'
import { ListingFlag } from "../ListingTile";

const JobTile = ({ location, title, price, rate, description, postedOn, id, onIntersection, type, className, ...props }) => {
  const orElse = () => { }
  return (
    <Observer onChange={onIntersection || orElse} threshold={1}>
      <NavLink to={"/job/" + id} className={`job-tile-base ${type} ` + className} {...props}>
        {type ? (
          <ListingFlag type={type}>
            {type === "featured" ? "FEATURED" : "NEWLY POSTED"}
          </ListingFlag>
        ) : undefined}
        <div className="job-tile-location">{location}</div>
        <span className="job-tile-title">{title}</span>
        {price && <div className="job-tile-price-rate">
          {<span className="job-tile-price">${price}</span>}
        </div>}
        <span className="job-tile-description" dangerouslySetInnerHTML={{ __html: description }}>
        </span>
        <span className="job-tile-posted-on">Posted on&nbsp;{(new Date(postedOn)).toDateString()}</span>
      </NavLink>
    </Observer>
  )
};

export default JobTile;
